enum ECompareMode {
  Grid = 'Grid',
  Row = 'Row',
}

export default ECompareMode;
